import { useEffect, useRef, useState } from 'react';
import Typewriter from 'typewriter-effect';

// `app/24/TypewriterTitle.js` — every section heading types itself out the first time it
// scrolls into view, then stops observing.
export default function TypewriterTitle({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = titleRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { root: null, rootMargin: '0px', threshold: 0.1 },
    );

    observer.observe(node);

    return () => observer.unobserve(node);
  }, []);

  return (
    <div ref={titleRef} className={className}>
      {isVisible && (
        <Typewriter
          options={{ strings: text, autoStart: true, loop: false, delay: 35 }}
        />
      )}
    </div>
  );
}
